
	<ib-image [source]='imageSource' [alt]='imageAlt' [class]='hostClasses' (click)='onClick("img")'></ib-image>
	<div><ng-content (click)='onClick("txt")'></ng-content></div>
